<template>
  <a-popover
    v-model:open="showEmojiPopover"
    :title="null"
    overlayClassName="emoji-popover"
    trigger="click"
    placement="topLeft"
    arrowPointAtCenter
    @openChange="onPopoverOpenChange"
  >
    <ActionButton
      type="emoji"
      @click="handleShowPicker"
      preventEvent
      :disabled="props.disabled"
      :icon-styles="props.iconStyles"
      :from-ant="iconFromAnt"
    />

    <template #content>
      <!-- <EmojiPicker
        native
        hide-search
        hide-group-icons
        disable-skin-tones
        :group-names="groupNamesProp"
        @select="handleChangeEmoji"
        :additional-groups="myFilteredEmojiGroups"
      /> -->

      <EmojiPicker
        :native="!omitComposed"
        hide-search
        hide-group-icons
        disable-skin-tones
        :group-names="omitComposed ? [] : groupNamesProp"
        :emojis="myFilteredEmojiGroups"
        @select="handleChangeEmoji"
      />
       
    </template>
  </a-popover>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import EmojiPicker from "vue3-emoji-picker";
import "vue3-emoji-picker/css";
import ActionButton from "@/app/workspace/components/chat/input/ActionButton.vue";
import { groupNames } from "@/app/workspace/utils/emojiPickerOptions";
import type { Emoji } from "@/@types/workspace";
import emojisData from "@/app/shared/assets/emojis.json";
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  iconStyles: {
    type: Object,
    required: false,
  },
  iconFromAnt: {
    type: Boolean,
    default: false,
  },
  omitComposed: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["onChangeEmoji", "handleShowPicker"]);

const showEmojiPopover = ref<boolean>(false);

const onPopoverOpenChange = (val: boolean) => {
  if (props.disabled) {
    // Evitar que se abra si está deshabilitado
    showEmojiPopover.value = false
    return
  }
  showEmojiPopover.value = val
}

const handleShowPicker = () => {
  if (props.disabled) return;
  console.log("is here");
  showEmojiPopover.value = true;
  emits("handleShowPicker");
};

function unicodeToEmoji(unicode: string) {
  return unicode
    .split('-')
    .map(u => String.fromCodePoint(parseInt(u, 16)))
    .join('');
}

function isComposedFromUnicode(unicode: string, names: string[]) {
  // const lowerNames = names.map(n => n.toLowerCase());

  // Caso 1: Tiene Zero Width Joiner -> compuesto
  if (unicode.toLowerCase().includes('200d')) return true;

  // Caso 2: Es un emoji precompuesto de combinación (familias, parejas, besos, etc.)
  // const keywords = [
  //   'family', 'man-woman', 'man-man', 'woman-woman', 
  //   'couple', 'kiss', 'holding hands'
  // ];
  // if (lowerNames.some(name => keywords.some(kw => name.includes(kw)))) {
  //   return true;
  // }

  return false;
}

const isEmojiComposed = (emoji: any) => {
  // El ZWJ indica que es un emoji compuesto
  return emoji.includes("\u200D");
}

const myFilteredEmojiGroups = computed(() => {
  const filtered = Object.fromEntries(
    Object.entries(emojisData).map(([groupKey, items]) => [
      groupKey,
      props.omitComposed
        ? items.filter(e => !isComposedFromUnicode(e.u, e.n) && !isEmojiComposed(unicodeToEmoji(e.u)))
        : items,
    ])
  );

  console.log(filtered, 'filtered');
  // console.log(notFiltered, 'notFiltered');

  return filtered;
});

const groupNamesProp = computed(() =>
  props.omitComposed ? [] : groupNames
);


const handleChangeEmoji = (emojiMetadata: Emoji) => {
  if (props.disabled) return;
  emits("onChangeEmoji", emojiMetadata);
  showEmojiPopover.value = false;
};
</script>

<style>
.emoji-popover .ant-popover-inner-content {
  padding: 0 !important;
}

.v3-emoji-picker {
  box-shadow: none !important;
}

.v3-emoji-picker.v3-color-theme-light .v3-footer {
  display: none;
}
</style>
